/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsDashboardRequestBase {
    getFixupPrototypeFunction() { return AppSecopsDashboardRequestBase.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsDashboardRequestBase>): AppSecopsDashboardRequestBase {
        let obj = Object.assign(new AppSecopsDashboardRequestBase(), model);
        AppSecopsDashboardRequestBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsDashboardRequestBase>): AppSecopsDashboardRequestBase {
        if (!model) return null;
        return AppSecopsDashboardRequestBase.newInstance(<AppSecopsDashboardRequestBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsDashboardRequestBase) {
        if (!obj) return;

        models.AppSecopsDashboardRequestBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsDashboardRequestBase): boolean {
        Object.setPrototypeOf(obj, AppSecopsDashboardRequestBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of tenant IDs
     */
    tenant_ids: Array<string>;

}
